import { Flex, FlexProps, Spin, SpinProps } from "antd";
import React from "react";

interface AntDSpinProps {
  flexProps?: Omit<FlexProps, "children">;
  spinProps?: SpinProps;
}

export const AntDSpin: React.FC<AntDSpinProps> = ({
  flexProps = {},
  spinProps = {}
}) => {
  const {
    justify = "center",
    align = "center",
    style,
    ...restFlexProps
  } = flexProps;

  return (
    <Flex
      align={align}
      justify={justify}
      style={{ height: "100%", width: "100%", ...style }}
      {...restFlexProps}
    >
      <Spin {...spinProps} />
    </Flex>
  );
};
